/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/MassageGun/gunBody.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.圓柱體001.geometry} material={materials.材質} />
      <mesh geometry={nodes.圓柱體001_1.geometry} material={materials['材質.004']} />
    </group>
  )
}

useGLTF.preload('/MassageGun/gunBody.glb')
